module.exports = __webpack_public_path__ + "static/partner-603620ee6668357b3995bfd6dfb17a04.png";